<ngx-extended-pdf-viewer class="h-100 w-100 position-absolute" src="assets/pdfs/terms_conditions.pdf" [sidebarVisible]="false" [showToolbar]="false" />

